export const EMPTY_MARKS = {
    type: {
        automatic: true,
    },
    options: {},
    angle: { values: [] },
    color: { values: [] },
    detail: { values: [] },
    label: { values: [] },
    size: { values: [] },
    text: { values: [] },
    tooltip: { values: [] },
    baseline: { values: [] },
};
